import { Listing } from 'shared/interfaces';

/**
 * Checks if listing is zero cost.
 *
 * @param value Partial Listing info.
 * @return Returns true if is zero cost, else false.
 */
export const isListingZeroCost = (listing: Partial<Listing>) => {
  return listing?.cost === 0;
};
